import {http, turnHttp} from '@/utils';

/**
 * TurntableV2InfoResponse
 */
export interface TurntableV2InfoResponse {
  /**
   * id
   */
  id?: number;
  /**
   * 转盘明细
   */
  info?: TurntableLevel[];
  /**
   * 名称
   */
  name?: string;
  /**
   * 图片
   */
  pic?: string;
}

/**
 * see
 *
 * TurntableLevel
 */
export interface TurntableLevel {
  /**
   * 奖励名数量
   */
  count?: number;
  /**
   * 终点角度 (不包含) (按照坐标系)
   */
  endDeg?: number;
  /**
   * 奖励等级
   */
  level?: number;
  /**
   * 奖励名字
   */
  name?: string;
  /**
   * 起点角度 (包含) (按照坐标系)
   */
  startDeg?: number;
}

export const getUserWeightInfo = () => {
  return http.post<null, {turnableId: string | number}>('app/user/weight/info');
};

export function getActualSpinInfo(turnableId: string | number) {
  return turnHttp.post<null, TurntableV2InfoResponse>(
    'turntable/v2/center/info',
    {
      id: turnableId,
    },
  );
}

export function getSpinCountInfo() {
  return http.post<null, number>('app/user/turnable/count');
}

interface UserDrawResponse {
  awardName: string;
  awardPrice: number;
  awardUrl: string;
  customerImUrl?: string;
}

export function userDraw() {
  return http.post<null, UserDrawResponse>('app/new-user/turntable/draw');
}

export interface GetUserSpinRecordParams {
  turntableId?: string | number;
  pageNo: number;
  pageSize: number;
}

export interface GetUserSpinRecordItem {
  awardCount: number;
  awardName: string;
  awardPic: string;
  awardType: string;
  createTime: number;
  id: number;
  itemNo: number;
  level: number;
  orderNo: string;
  packageId: number;
  price: number;
  // 0 待发放 1 拦截 2 已发放
  status: number;
  turntableId: number;
  turntableName: string;
  updateTime: number;
  userId: number;
  userPhone: string;
}

export function getSpinTop(turnId: string | number) {
  return http.post<null, GetUserSpinRecordItem[]>(
    'app/new-user/turntable/draw/result/by/turnid',
    {
      turntableId: turnId,
    },
  );
}

export function getUserSpinRecord(params: GetUserSpinRecordParams) {
  return http.post<null, GetUserSpinRecordItem[]>(
    'app/new-user/turntable/draw/result/by/userid',
    params,
  );
}
